module.exports = new __parcel__URL__("shop_machines_mercenary_wolvez_hideout.d2014759.png").toString();